/*=========================================================================================
  File Name: moduleTodo.js
  Description: Todo Module
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


import state from './moduleUserCoursesState.js'
import mutations from './moduleUserCoursesMutations.js'
import actions from './moduleUserCoursesActions.js'
import getters from './moduleUserCoursesGetters.js'

export default {
  namespaced: true,
  isRegistered: false,
  state,
  mutations,
  actions,
  getters
}
